
<template>

  <div class="content">
    <!-- 创建桌面快捷方式 -->
    <div v-if="create" class="createAppBox">
      <div class="title">添加服务到桌面</div>
      <div class="rel">
        <img class="desktop" src="../../assets/img/desktop.jpg" alt=""/>
        <img class="createIcon" :src="appIcon" alt=""/>
      </div>
      <div class="guide_box">
          <div class="guide_title"><span>第一步：</span>点击底部工具</div>
          <img class="guide" src="../../assets/img/guide.png" alt=""/>
          <div class="guide_title"><span>第二步：</span>在弹出框中点击"添加到主屏幕"</div>
          <img class="creat" src="../../assets/img/creat.png" alt=""/>
      </div>
    </div>
    <!-- 打开app -->
    <div v-else class="openAppBox">
      <div class="openTitle">你即将进入</div>
      <img class="appIcon" :src="appIcon" alt=""/>
      <div class="appTitle">{{appTitle}}</div>
      <div class="openApp" @click="openapp">立即进入</div>
    </div>
    <a id="myLink" :href="urlScheme"></a>
  </div>
</template>

<script>
// appId=1326702007&appName=扫一扫&appIcon=icon&smallPlatform=1&expertId=1
export default {
  data() {
    return {
      create:true,
      dynamicTitle: '',
      title:'',
      appId:'1326702007',
      appIcon:'http://192.168.1.58:8888/uploads/-/system/user/avatar/65/avatar.png?width=40',
      appTitle:'禧越',
      urlScheme:'testappdgmbuyer://',
      appStore:'https://crar.t4m.cn/'
    };
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { name: 'apple-mobile-web-app-capable', content: 'yes' }, // 启用全屏模式
        { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' }, // 状态栏样式
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
        { name: 'description', content: '这是一个可以在iOS上添加到主屏幕的应用程序示例。' }
      ],
      link: [
        { rel: 'apple-touch-icon', href: this.appIcon }, // 添加主屏幕图标
        { rel: 'apple-touch-startup-image', href: '' } // 可选：添加启动画面
      ]
    };
  },
  mounted() {
    console.log('参数=',this.$route.query);
    let { appName, appIcon, expertId, source } = this.$route.query;
    let isStandalone = ("standalone" in window.navigator) && window.navigator.standalone;//从主屏幕的打开的H5项目
    console.log('isStandalone=',isStandalone);
    // || source === 'shortcut'
    if (isStandalone) {
      this.create = false;
      this.title = appName;
      this.appIcon = appIcon;
      this.expertId = expertId;
      this.urlScheme = `${this.urlScheme}?expertId=${this.expertId}`;
      setTimeout(()=>{
        this.openapp();
      },1)
    } else {
      console.log('应用不是通过主屏幕快捷方式启动的');
      if(this.appIcon){
        this.create = true;
        this.title = appName;
        this.appIcon = appIcon;
        this.expertId = expertId;
      }
    }
    this.$nextTick(() => {
      this.$meta().refresh();
    });
  },
  created() {
      console.log('created');
  },
  methods: {
    // 打开app
    openapp() {
      document.getElementById('myLink').click();
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #F3F2F2;
}
.title {
  font-size: 18px;
  padding-top: 30px;
  font-weight: bold;
}
.desktop {
  width: 260px;
  height: 200px;
  margin: 30px auto;
}
.guide_box {
  text-align: left;
  padding: 25px 25px 0 25px;
  box-sizing: border-box;
  color: #222222;
  position: fixed;
  bottom: 10px;
  left: 0;
}
span {
  color: #1b7bfe;
}
.guide_title {
  font-size: 15px;
  padding: 20px 0;
  font-weight: bold;
}
.guide {
  width: 325px;
}
.creat {
  width: 325px;
}
.appIcon {
  width: 45px;
  height: 45px;
}
.openTitle {
  font-size: 14px;
  margin: 100px 0 30px 0;
  text-align: center;
}
.appTitle {
  font-size: 16px;
  padding-top: 10px;
}
.openApp, #myLink {
  position: fixed;
  bottom: 30px;
  font-size: 16px;
  background: #1b7bfe;
  color: #ffffff;
  width: 325px;
  margin: 0 25px;
  padding: 6px 0;
  border-radius: 2px;
  z-index: 2;
}
#myLink {
  visibility: hidden;
  z-index: 0;
}
.rel {
  position: relative;
}
.createIcon {
  position: absolute;
  top: 74px;
  left: 174px;
  width: 130px;
  height: 130px;
  border-radius: 30px;
}

</style>
